/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_business_api_keys_request_submitted_pending_note = /** @type {(inputs: {}) => string} */ () => {
	return `Este proceso suele tomar 1–2 días hábiles. No se genera ninguna llave hasta la aprobación.`
};

const en_developer_business_api_keys_request_submitted_pending_note = /** @type {(inputs: {}) => string} */ () => {
	return `This process typically takes 1–2 business days. No API key is generated until approval.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_business_api_keys_request_submitted_pending_note = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_business_api_keys_request_submitted_pending_note(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_business_api_keys_request_submitted_pending_note", locale)
	if (locale === "es") return es_developer_business_api_keys_request_submitted_pending_note(inputs)
	return en_developer_business_api_keys_request_submitted_pending_note(inputs)
};
export { developer_business_api_keys_request_submitted_pending_note as "developer.business_api_keys.request_submitted.pending_note" }